import wx from 'weixin-js-sdk'
// 跳转url
export function jumpUrl(url, dataId) {
  console.log(url)
  if (!url) {
    return
  }
  // 如果url不包含http://或者https://，则自动添加
  // if (url.indexOf('http://') === -1 && url.indexOf('https://') === -1) {
  //   url = 'http://' + url
  // }
  // // 如果url包含/poster/gen 则添加dataId参数
  // if (url.indexOf('/poster/gen') !== -1) {
  //   url = addUrlParam(url, 'dataId', dataId)
  // }
  // 如果url包含http://或者https://，则判断为网页地址
  const isWebUrl = url.indexOf('http://') !== -1 || url.indexOf('https://') !== -1
  setTimeout(() => {
    if (isWebUrl) window.location.replace(url)
    else wx.miniProgram.redirectTo({ url })
  }, 1000)
}

/**
 * 给url添加参数
 */
export function addUrlParam(url, name, value) {
  if (url.indexOf('?') !== -1) {
    url += '&'
  } else {
    url += '?'
  }
  url += name + '=' + value
  return url
}

export function goBack() {
  wx.miniProgram.reLaunch({ url: '/pages/entry/index' })
}
